import { createWebHistory, createRouter } from "vue-router";
import adminRoutes from "./AdminRoutes";
import authRoutes from "./guestRoutes";
import store from "@/vuex/store";
import { useMessage } from "../composables";

const { errorMessage } = useMessage();

const routes = [
  {
    name: "Admin",
    path: "/",
    redirect: "/dashboard",
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/layout/withAdminLayout.vue"),
    children: adminRoutes,
  },
  {
    name: "Auth",
    path: "/auth",
    component: () =>
      import(/* webpackChunkName: "auth" */ "@/layout/withAuthLayout"),
    children: authRoutes,
    meta: { auth: false },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("@/layout/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(
    process.env.NODE_ENV === "production"
      ? process.env.VUE_APP_SUB_ROUTE
        ? process.env.VUE_APP_SUB_ROUTE
        : process.env.BASE_URL
      : process.env.BASE_URL
  ),
  linkExactActiveClass: "active",
  routes,
});

router.beforeEach((to, from, next) => {
  const loggedIn = store.state.auth.login;
  const isAuth = to.matched.some((record) => record.meta.auth);
  if (isAuth && loggedIn) {
    const userRole = store.getters.getCurrent?.role || "";
    const roles = to.meta.roles || [];
    if (roles.indexOf(userRole) > -1) {
      next();
    } else {
      next({ name: "Dashboard" });
      errorMessage("You're not authorized to enter this page");
      return;
    }
  } else if (to.name === "login" && loggedIn) {
    next("/");
  } else if (!loggedIn && isAuth) {
    next("/auth/login");
  } else {
    next();
  }

});

export default router;
